import { FC, ReactNode, useMemo, memo } from 'react'
import theme from '@utils/theme'
import { StyledWrapper } from './style'
interface RowProps {
  variant?: keyof JSX.IntrinsicElements
  children?: ReactNode
  bg?: keyof typeof theme.colors
  alignItems?: 'center' | 'flex-start' | 'flex-end' | 'stretch' | 'baseline'
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
  colGap?: number
  rowGap?: number
  styleRow?: string
  onClick?: (event: any) => void
  hidden?: boolean
}
const Row: FC<RowProps> = memo(
  ({ children, variant = 'div', ...restProps }) => {
    const Component = useMemo(
      () => StyledWrapper.withComponent(variant),
      [variant],
    )
    return <Component {...restProps}>{children}</Component>
  },
)

export default Row
